import { render, staticRenderFns } from "./CrmDealCard.vue?vue&type=template&id=b4ad9506&scoped=true"
import script from "./CrmDealCard.vue?vue&type=script&lang=js"
export * from "./CrmDealCard.vue?vue&type=script&lang=js"
import style0 from "./CrmDealCard.vue?vue&type=style&index=0&id=b4ad9506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ad9506",
  null
  
)

export default component.exports